export default function GS_Conditional_Formatting() {
  return (
    <div className="p-4">
      <h1>GS Conditional Formatting</h1>
    </div>
  );
}
